const ANSWER_TYPE = {
    OE: 'online-editor'
};
export default ANSWER_TYPE;